import gql from 'graphql-tag';

export default gql`
  mutation createCourseFeedback($create: CourseFeedbackCreateInput!) {
    createCourseFeedback(create: $create) {
      id
    }
  }
`;
